import functions from '../../functions';

if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        InnerBlocks,
    } = window.wp.editor;

    const ALLOWED_BLOCKS = ['core/gallery'];

    registerBlockType('custom-gutenberg/content-gallery', {
        // built-in attributes
        title: 'Content gallery',
        description: 'Content gallery',
        icon: '',
        category: 'custom-containers',
        example: {},

        // built-in functions
        edit({ attributes, setAttributes, className }) {

            const {
                classes
            } = attributes;

            className = functions.getClassNames(className);
            if(classes != className) setAttributes({classes: className});

            const MY_TEMPLATE = [
                [ 'core/gallery', {} ],
            ];

            return (
                <div class={ "content-gallery " + classes }>
                    <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } template={ MY_TEMPLATE } />
                </div>
            );
        },

        save({ attributes }) {

            const {
                classes
            } = attributes;

            return (
                <div className="content-gallery">
                    <InnerBlocks.Content />
                </div>
            );
        },
    });
}